/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ScheduledOccupancyType = {
    MoveOuts: 'MOVE_OUTS',
    MoveIns: 'MOVE_INS',
} as const;
export type ScheduledOccupancyType = typeof ScheduledOccupancyType[keyof typeof ScheduledOccupancyType];


export function instanceOfScheduledOccupancyType(value: any): boolean {
    for (const key in ScheduledOccupancyType) {
        if (Object.prototype.hasOwnProperty.call(ScheduledOccupancyType, key)) {
            if (ScheduledOccupancyType[key as keyof typeof ScheduledOccupancyType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ScheduledOccupancyTypeFromJSON(json: any): ScheduledOccupancyType {
    return ScheduledOccupancyTypeFromJSONTyped(json, false);
}

export function ScheduledOccupancyTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduledOccupancyType {
    return json as ScheduledOccupancyType;
}

export function ScheduledOccupancyTypeToJSON(value?: ScheduledOccupancyType | null): any {
    return value as any;
}

export function ScheduledOccupancyTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ScheduledOccupancyType {
    return value as ScheduledOccupancyType;
}

